<h3-feedback-panel [dialogTitle]="getTitle()" (panelClose)="close()">
  <h3-upsert-feedback
    [possibleErrorTags]="possibleErrorTags"
    [feedback]="selectedHighlight"
    (save)="saveHighlight($event)"
  ></h3-upsert-feedback>
</h3-feedback-panel>
